import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "clearfix" };
const _hoisted_2 = { class: "card m-0" };
const _hoisted_3 = { class: "card-body p-1" };
const _hoisted_4 = { class: "col-xs-12 col-sm-12 col-md-12 p-0 clearfix" };
const _hoisted_5 = { class: "tile_summary" };
const _hoisted_6 = { class: "tile_summary_count" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("label", null, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-desktop" }),
    /*#__PURE__*/ _createTextVNode(" ")
], -1 /* HOISTED */);
const _hoisted_8 = { class: "tile_summary_count healthy" };
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("label", null, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-check-circle-o" }, " ")
], -1 /* HOISTED */);
const _hoisted_10 = { class: "d-flex align-items-center tile_summary_count warning" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("label", null, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-bell" }),
    /*#__PURE__*/ _createTextVNode(" ")
], -1 /* HOISTED */);
const _hoisted_12 = { class: "ack_nack_status" };
const _hoisted_13 = { class: "w-100 text-end" };
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("label", null, "ACK: ", -1 /* HOISTED */);
const _hoisted_15 = { class: "w-100 text-end" };
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("label", null, "NACK: ", -1 /* HOISTED */);
const _hoisted_17 = { class: "d-flex align-items-center tile_summary_count critical" };
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("label", null, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-exclamation-triangle" }),
    /*#__PURE__*/ _createTextVNode(" ")
], -1 /* HOISTED */);
const _hoisted_19 = { class: "ack_nack_status" };
const _hoisted_20 = { class: "w-100 text-end" };
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("label", null, "ACK: ", -1 /* HOISTED */);
const _hoisted_22 = { class: "w-100 text-end" };
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("label", null, "NACK: ", -1 /* HOISTED */);
const _hoisted_24 = { class: "tile_summary_count unknown" };
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("label", null, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-question-circle-o" }),
    /*#__PURE__*/ _createTextVNode(" ")
], -1 /* HOISTED */);
const _hoisted_26 = { class: "data-grid main-status-grid detached overflow-x-auto" };
const _hoisted_27 = { class: "table table-hover bottom0 pw100" };
const _hoisted_28 = /*#__PURE__*/ _createElementVNode("th", { class: "text-center w120" }, "\r\n\t\t\t\t\t\tACK\r\n\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_29 = /*#__PURE__*/ _createElementVNode("th", { class: "text-center w120" }, "\r\n\t\t\t\t\t\tNACK\r\n\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_30 = { class: "w20 min-width20" };
const _hoisted_31 = {
    class: /*#__PURE__*/ _normalizeClass(['alarm'])
};
const _hoisted_32 = ["onClick"];
const _hoisted_33 = {
    key: 0,
    class: "text-center alarm-count",
    colspan: "2"
};
const _hoisted_34 = {
    key: 1,
    class: "text-center alarm-count"
};
const _hoisted_35 = {
    key: 0,
    class: "badge critical"
};
const _hoisted_36 = {
    key: 1,
    class: "badge warning"
};
const _hoisted_37 = {
    key: 2,
    class: "text-center alarm-count"
};
const _hoisted_38 = {
    key: 0,
    class: "badge critical"
};
const _hoisted_39 = {
    key: 1,
    class: "badge warning"
};
const _hoisted_40 = {
    key: 3,
    class: "alarm-count"
};
const _hoisted_41 = {
    key: 0,
    class: "badge icon-only unknown"
};
const _hoisted_42 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-question-circle-o" }, null, -1 /* HOISTED */);
const _hoisted_43 = [
    _hoisted_42
];
const _hoisted_44 = {
    key: 1,
    class: "badge icon-only healthy"
};
const _hoisted_45 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-check-circle-o" }, null, -1 /* HOISTED */);
const _hoisted_46 = [
    _hoisted_45
];
const _hoisted_47 = { key: 4 };
const _hoisted_48 = { key: 0 };
const _hoisted_49 = /*#__PURE__*/ _createElementVNode("tr", null, [
    /*#__PURE__*/ _createElementVNode("td", {
        class: "text-center",
        colspan: "5"
    }, [
        /*#__PURE__*/ _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t")
    ])
], -1 /* HOISTED */);
const _hoisted_50 = [
    _hoisted_49
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_SortableColumnComponent = _resolveComponent("SortableColumnComponent");
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _hoisted_7,
                                _createTextVNode(),
                                _createElementVNode("span", null, _toDisplayString(_ctx.visibleSystems.length), 1 /* TEXT */)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_8, [
                                _hoisted_9,
                                _createTextVNode(),
                                _createElementVNode("span", null, _toDisplayString(_ctx.getFilteredSystemsHealthy), 1 /* TEXT */)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_10, [
                                _hoisted_11,
                                _createTextVNode(),
                                _createElementVNode("span", null, _toDisplayString(_ctx.getFilteredSystemsWarning), 1 /* TEXT */),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_12, [
                                    _createElementVNode("div", _hoisted_13, [
                                        _hoisted_14,
                                        _createTextVNode(),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.getFilteredAckWarningAlarms), 1 /* TEXT */)
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_15, [
                                        _hoisted_16,
                                        _createTextVNode(),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.getFilteredNackWarningAlarms), 1 /* TEXT */)
                                    ])
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_17, [
                                _hoisted_18,
                                _createTextVNode(),
                                _createElementVNode("span", null, _toDisplayString(_ctx.getFilteredSystemsCritical), 1 /* TEXT */),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_19, [
                                    _createElementVNode("div", _hoisted_20, [
                                        _hoisted_21,
                                        _createTextVNode(),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.getFilteredAckCriticalAlarms), 1 /* TEXT */)
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_22, [
                                        _hoisted_23,
                                        _createTextVNode(),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.getFilteredNackCriticalAlarms), 1 /* TEXT */)
                                    ])
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_24, [
                                _hoisted_25,
                                _createTextVNode(),
                                _createElementVNode("span", null, _toDisplayString(_ctx.filteredSystemsUnknown), 1 /* TEXT */)
                            ])
                        ])
                    ])
                ])
            ])
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_26, [
            _createElementVNode("table", _hoisted_27, [
                _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                        _createElementVNode("th", null, [
                            _createVNode(_component_SortableColumnComponent, {
                                sorter: _ctx.sorter,
                                column: { fieldName: 'SystemName', title: 'System' }
                            }, null, 8 /* PROPS */, ["sorter"])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("th", null, [
                            _createVNode(_component_SortableColumnComponent, {
                                sorter: _ctx.sorter,
                                column: { fieldName: 'SiteName', title: 'Site' }
                            }, null, 8 /* PROPS */, ["sorter"])
                        ]),
                        _createTextVNode(),
                        _hoisted_28,
                        _createTextVNode(),
                        _hoisted_29,
                        _createTextVNode(),
                        _createElementVNode("th", _hoisted_30, [
                            _createVNode(_component_SortableColumnComponent, {
                                sorter: _ctx.sorter,
                                column: { fieldName: 'NumberOfAlarms', title: '' }
                            }, null, 8 /* PROPS */, ["sorter"])
                        ])
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleSystems, (system, index) => {
                        return (_openBlock(), _createElementBlock("tr", _hoisted_31, [
                            _createElementVNode("td", null, [
                                _createElementVNode("span", {
                                    class: "pointer blue",
                                    onClick: ($event) => (_ctx.goToSystemView(system))
                                }, _toDisplayString(system.systemName), 9 /* TEXT, PROPS */, _hoisted_32)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("td", null, _toDisplayString(_ctx.getAddressLine(system)), 1 /* TEXT */),
                            _createTextVNode(),
                            (!_ctx.hasAlarms(system))
                                ? (_openBlock(), _createElementBlock("td", _hoisted_33))
                                : _createCommentVNode("v-if", true),
                            _createTextVNode(),
                            (_ctx.hasAlarms(system))
                                ? (_openBlock(), _createElementBlock("td", _hoisted_34, [
                                    (system.numberOfCriticalAlarmsAck)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                            _createVNode(_component_router_link, {
                                                to: { name: 'system-alarms', params: { systemId: system.systemId, alarmSeverity: 'critical', acknowledgeStatus: 1 } }
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.getAlarmAckCount(system, 'critical')), 1 /* TEXT */)
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _createTextVNode(),
                                    (system.numberOfWarningAlarmsAck)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                            _createVNode(_component_router_link, {
                                                to: { name: 'system-alarms', params: { systemId: system.systemId, alarmSeverity: 'warning', acknowledgeStatus: 1 } }
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.getAlarmAckCount(system, 'warning')), 1 /* TEXT */)
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                                        ]))
                                        : _createCommentVNode("v-if", true)
                                ]))
                                : _createCommentVNode("v-if", true),
                            _createTextVNode(),
                            (_ctx.hasAlarms(system))
                                ? (_openBlock(), _createElementBlock("td", _hoisted_37, [
                                    (system.numberOfCriticalAlarmsNack)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                            _createVNode(_component_router_link, {
                                                to: { name: 'system-alarms', params: { systemId: system.systemId, alarmSeverity: 'critical', acknowledgeStatus: 0 } }
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.getAlarmNackCount(system, 'critical')), 1 /* TEXT */)
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _createTextVNode(),
                                    (system.numberOfWarningAlarmsNack)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                            _createVNode(_component_router_link, {
                                                to: { name: 'system-alarms', params: { systemId: system.systemId, alarmSeverity: 'warning', acknowledgeStatus: 0 } }
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.getAlarmNackCount(system, 'warning')), 1 /* TEXT */)
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                                        ]))
                                        : _createCommentVNode("v-if", true)
                                ]))
                                : _createCommentVNode("v-if", true),
                            _createTextVNode(),
                            (!_ctx.hasAlarms(system) || _ctx.getCssClass(system) == 'unknown')
                                ? (_openBlock(), _createElementBlock("td", _hoisted_40, [
                                    (_ctx.getCssClass(system) == 'unknown')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, _hoisted_43))
                                        : _createCommentVNode("v-if", true),
                                    _createTextVNode(),
                                    (!_ctx.hasAlarms(system) && _ctx.getCssClass(system) == 'healthy')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, _hoisted_46))
                                        : _createCommentVNode("v-if", true)
                                ]))
                                : (_openBlock(), _createElementBlock("td", _hoisted_47))
                        ]));
                    }), 256 /* UNKEYED_FRAGMENT */))
                ]),
                _createTextVNode(),
                (!_ctx.visibleSystems.length)
                    ? (_openBlock(), _createElementBlock("tfoot", _hoisted_48, _hoisted_50))
                    : _createCommentVNode("v-if", true)
            ])
        ])
    ], 64 /* STABLE_FRAGMENT */));
}
